import React from 'react';
import TableCell from '@/components/cell';
import ScoreCell from '@/components/reports/table-v2/enhancements/score';
export function FormattedCell({ type, align, key, formatter, colorGradient, result, onClick, }) {
    return (<TableCell onClick={onClick} type={type} align={align} key={key}>
      <ScoreCell formatter={formatter} colorGradient={colorGradient} result={result}/>
    </TableCell>);
}
export default FormattedCell;
